import {
  KnownImpressionTypes,
  KNOWN_IMPRESSION_TYPES,
} from '../AITools/ImpressionEditor/ImpressionItem';

export const AI_GENERATED_SYSTEM =
  'https://lifeomic.com/fhir/action-plan-ai-generated';

export const AI_GENERATED_SYSTEM_V2 =
  'https://lifeomic.com/fhir/fountain-life-ai-generated';

export const isAiGenerated = (
  item: fhir.CarePlanActivity['detail'] | fhir.ClinicalImpression,
): boolean => {
  return (
    item?.extension?.some(
      ext =>
        (ext?.url === AI_GENERATED_SYSTEM ||
          ext?.url === AI_GENERATED_SYSTEM_V2) &&
        ext?.valueBoolean === true,
    ) ?? false
  );
};

export const orderImpressionTypes = (
  impressionTypes: KnownImpressionTypes[],
) => {
  // we cast because we want to preserve any that are not allowed (backward compatibility)
  return impressionTypes.sort((impressionTypeA, impressionTypeB) => {
    const order =
      KNOWN_IMPRESSION_TYPES.indexOf(impressionTypeA) -
      KNOWN_IMPRESSION_TYPES.indexOf(impressionTypeB);
    return order;
  });
};

/**
 * Matches a Markdown footnote reference. This will also match the first part of a
 * footnote definition.
 */
export const footnoteRegexp =
  /(\s*\[footnote_ref:[A-Za-z0-9]+:[A-Za-z0-9_]+\](?!:))|(\s*\[\^[A-Za-z0-9_]+\](?!:))/g;

/**
 * Matches a markdown footnote definition.
 */
export const footnoteDefinitionRegexp =
  /^(?:\[footnote_ref:[A-Za-z0-9]+:[A-Za-z0-9_]+\]|\[\^[A-Za-z0-9_]+\]):.*$/gm;
